import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { DecimalStockCompanyPipe } from 'app/pipes/decimal-stock-company.pipe';

@Component({
    selector: 'app-quantity-sale-cell-renderer',
    standalone: true,
    imports: [CommonModule, DecimalPipe, DecimalStockCompanyPipe],
    template: `
                                                    <span class="f-9">
                                                        <b>UMB:</b> {{ params.data?.stockConfirmedERP | decimalStockCompany }}
                                                        ({{params.data?.baseUnitOfMeasure?.name}})<br>

                                                        <ng-container *ngIf="isUMPActive">
                                                            <b>UMP:</b>
                                                            <ng-container
                                                                *ngIf="params.data?.pararellUnitOfMeasure; else noUMP">
                                                                {{params.data?.stockConfirmedPararell | decimalStockCompany }}
                                                                ({{
                                                                params.data?.pararellUnitOfMeasure?.name }})
                                                            </ng-container>
                                                        </ng-container>
                                                        <ng-template #noUMP> - </ng-template>
                                                    </span>
  `,
})
export class QuantitySaleCellRendererComponent implements CellRenderer<any> {
    @Input() params!: CellRendererParams<any>;

    get isUMPActive(): boolean {
        const getUMPActive = this.params.colDef?.cellRendererParams?.getUMPActive;
        return typeof getUMPActive === 'function' ? getUMPActive() : false;
    }
}
